import _ from 'lodash';
import { Component, Input, Output,EventEmitter} from '@angular/core';
import { AlertService, QuotationService, TruckListModel, BookingSheetModel, CfsModel, CfsService, CnsltnCntrModel } from '../../../../services/index';

@Component({
  selector: 'cargo-information',
  templateUrl: 'cargo-information.html'
})


export class CargoInformation {
  @Input() cnsltnTruckLst;
  @Input() cnsltnReq;
  @Input() cnsltnBook;
  @Input() cnsltnShpnadv;
  @Input() cnsltnCntrLst;
  @Input() bookedQuot;
  @Output() fileListEe: EventEmitter<any> = new EventEmitter();

  cargoInformations;
  truckingList: Array<TruckListModel>;
  showSecondCntr: Array<boolean>;
  cntrList: Array<CnsltnCntrModel>;
  mBlNo;
  hBlNo;

  trucking:boolean = false;
  truckCon: boolean = false;

  postTruck: boolean = false;

  constructor(
    private alertService: AlertService,
    private quotationService: QuotationService,
  ) {}


  ngOnChanges() {
    if(this.cnsltnBook!= null) this.cargoInformations = this.cnsltnBook;
    if(this.cnsltnShpnadv!= null) this.cargoInformations = this.cnsltnShpnadv;

    let req = this.cnsltnReq;
    
    //reqTp, imexTp, transTp, orgTp == 0 :PORT 1:Door, desTp, stuffYn == 0 : 직접적입 가능,  stuffYn == 1:불가능 ,  transCfsYn == 0 : cfs운송 가능 , transCfsYn == 1 : 불가능

    // 수출 (Door -> ), 수입 ( -> Door) 인 경우
    if ((req.imexTp == 0 && req.orgTp == 1) || (req.imexTp == 1 && req.desTp == 1)) {
      // FCL
      if (req.reqTp == 0) {        
        // 직접 적입이 가능한경우 차량과 컨테이너가 필요함
        if (req.stuffYn == 0) {
          this.trucking = true;
          this.truckCon = true;
        // 직접 적입이 불가능한 경우 화물을 CFS까지 운송 해야 하며 직접 CFS까지 운송이 불가능한 경우 차량이 필요함
        } else if (req.transCfsYn==1) {
          this.trucking = true;
        }
      // LCL 은 운송이 필요함
      } else if (req.reqTp == 1) {
        this.trucking = true;  
      }
    }
    
    if(!_.isEmpty(this.cnsltnTruckLst)) {
      this.truckingList = this.cnsltnTruckLst;
      this.truckingList.forEach(
        trucking => {
          if (!trucking.cntrList && this.truckCon) trucking.cntrList = [new CnsltnCntrModel()];
        }
      );
    } else {
      this.truckingList = [new TruckListModel()];
      if(this.truckCon) this.truckingList[0].cntrList = [new CnsltnCntrModel()]; 
    }

    if(this.cnsltnCntrLst != null) { 
      this.cntrList = this.cnsltnCntrLst;
    } else {
      this.cntrList = [new CnsltnCntrModel()];
    }

    if(this.cnsltnReq.mblNo != null) this.mBlNo = this.cnsltnReq.mblNo;
    if(this.cnsltnReq.hblNo != null) this.hBlNo = this.cnsltnReq.hblNo;
  }

  postTruckingYn(event) {
    console.log(event);
    if(event) {
      if(this.cnsltnReq.imexTp == 0) {
        this.quotationService.postBookTruck(1, this.cnsltnReq.reqNo).subscribe();    
      } else {
        this.quotationService.postShipTruck(1, this.cnsltnReq.reqNo).subscribe();    
      }
    } else {
      if(this.cnsltnReq.imexTp == 0) {
      this.quotationService.postBookTruck(0, this.cnsltnReq.reqNo).subscribe();
      } else {
        this.quotationService.postShipTruck(0, this.cnsltnReq.reqNo).subscribe();
      }
    } 
  }

  addTruckingInfo() {
    let trucking = new TruckListModel()
    if (this.truckCon) trucking.cntrList = [new CnsltnCntrModel()];
    this.truckingList.push(trucking);
  }

  deleteTruckingInfo(i) {
    this.truckingList.splice(i, 1);
  }

  addTruckContainer(i) {
    if (!this.truckingList[i].cntrList) this.truckingList[i].cntrList = [];
    this.truckingList[i].cntrList.push(new CnsltnCntrModel());
  }

  deleteTruckContainer(i, j) {
    this.truckingList[i].cntrList.splice(j, 1);
  }

  addContainer() {
    this.cntrList.push(new CnsltnCntrModel());
  }

  deleteContainer(i) {
    this.cntrList.splice(i, 1);
  }
 
  postCargoInformations() {
    for(let i = 0; i<this.truckingList.length; i++) {
      this.truckingList[i].reqNo = this.cnsltnReq.reqNo;
    }

    let body = {
      lineCd: this.bookedQuot.linerCd,
      bl: {mBlNo: this.mBlNo, hBlNo: this.hBlNo, blYy: ""},
      cntrList: this.cntrList
    };

    if(this.trucking && this.truckCon) {
      _.assign(body, {truckingList: this.truckingList});
    } else if(this.trucking && !this.truckCon) {
      _.assign(body, {truckingList: this.truckingList});
    }
  
    this.postTruck = true;
    this.quotationService.postTrucking(body, this.cnsltnReq.reqNo).subscribe(
      resp=> {
        if(resp.result) {
          this.alertService.success('화물정보가 저장되었습니다.');
          this.fileListEe.emit();
        } else {
          this.alertService.error('오류가 발생했습니다. 다시 시도해 주세요.');
        }
      },
      error => { 
        this.postTruck = false;
        this.alertService.error('오류가 발생했습니다. 다시 시도해 주세요.')
      },
      () => this.postTruck = false
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/cargo-information.ts